import type { AppModule } from '@/core/register-modules';

import * as routes from './routes';

export const VerbsModule: AppModule = {
  routes,
};
